import React from 'react';
import { motion } from 'framer-motion';
import { useTheme } from '../context/ThemeContext';
import './AnimatedLogo.css';

const AnimatedLogo = ({ size = 48 }) => {
  const { theme } = useTheme();
  
  return (
    <div className="animated-logo-badge" style={{ width: size, height: size }}>
      <motion.div 
        className="animated-logo-ring"
        animate={{ rotate: 360 }}
        transition={{
          duration: 4.2,
          repeat: Infinity,
          ease: "linear"
        }}
      />
      <div className="animated-logo-ring-inner" />
      <div className="animated-logo-core">
        <svg 
          className="animated-logo-svg" 
          viewBox="0 0 100 100"
          style={{ width: size * 0.8, height: size * 0.8 }}
        >
          <defs>
            <linearGradient id="logo-text-gradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#ffb37a"/>
              <stop offset="100%" stopColor="#f9741c"/>
            </linearGradient>
          </defs>
          <text 
            x="50" 
            y="43" 
            fontFamily="Baloo 2, sans-serif" 
            fontWeight="800" 
            fontSize="16.5" 
            fill="url(#logo-text-gradient)" 
            textAnchor="middle" 
            letterSpacing="0.4"
          >
            MULTI
          </text>
          <text 
            x="50" 
            y="65" 
            fontFamily="Baloo 2, sans-serif" 
            fontWeight="800" 
            fontSize="16.5" 
            fill={theme === 'light' ? '#1a1a1a' : '#fff'}
            textAnchor="middle" 
            letterSpacing="0.4"
          >
            TOOLS
          </text>
        </svg>
      </div>
    </div>
  );
};

export default AnimatedLogo;
